export const couponTypeEnums = {
  campaign: 'Marketing Campaign',
  tenant: 'Customer',
};

export const discountTypeEnums = {
  percentOff: 'Percent Off',
  amountOff: 'Amount Off',
};

export const discountDurationEnums = {
  once: 'Once',
  repeating: 'Repeating',
};

export const redemptionCodeEnums = {
  auto: 'Auto',
  custom: 'Custom',
};

export const numberOfRedemptionEnums = {
  unlimited: 'Unlimited',
  custom: 'Custom',
};

export const maxCouponIdLength = 32;
